export const environment = {
  serverPath: process.env.REACT_APP_SERVER_URL as string,
  environment: process.env.REACT_APP_ENVIRONMENT as string,
  googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY as string,
};
